import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import CatalogueBanner from '../components/CatalogueBanner';
import './CataloguePage.css';
import Footer from '../components/Footer';

const CataloguePage = () => {
    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="catalogue-page">
            <Navbar />

            <main className="catalogue-page-content">
                <CatalogueBanner />
                
            </main>
            <Footer/>
        </div>
    );
};

export default CataloguePage;
